import React, { createContext, useContext, useState } from "react";

const DrawerContext = createContext();

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error("useDrawer must be used within DrawerProvider");
  }
  return context;
};

export const DrawerProvider = ({ children }) => {
  const [drawerState, setDrawerState] = useState({
    isOpen: false,
    title: "",
    subtitle: "",
    items: [],
    onItemClick: null,
    courseName: "",
    subjectName: "",
    selectedId: null,
  });

  const openDrawer = ({
    title,
    subtitle,
    items,
    onItemClick,
    courseName,
    subjectName,
    selectedId,
  }) => {
    setDrawerState({
      isOpen: true,
      title,
      subtitle,
      items,
      onItemClick,
      courseName: courseName || "",
      subjectName: subjectName || "",
      selectedId: selectedId || null,
    });
  };

  const closeDrawer = () => {
    setDrawerState((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <DrawerContext.Provider value={{ drawerState, openDrawer, closeDrawer }}>
      {children}
    </DrawerContext.Provider>
  );
};
